function moduleContentWithSlides() {
	/** @type {NodeListOf<HTMLElement>} */
	const modules = document.querySelectorAll('.module.content-with-slides');
	if (!modules || !modules.length) return;

	/** @param {HTMLElement} module */
	const initSwiper = (module) => {
		/** @type {HTMLElement} */
		const swiperContainer = module.querySelector('.swiper.content-with-slides-swiper');
		if (!swiperContainer) return;

		new Swiper(swiperContainer, {
			spaceBetween: 30,
			autoplay: {
				delay: 6000,
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'bullets',
				clickable: true,
			},
		});
	};

	for (const module of modules) {
		initSwiper(module);
	}
}
